import React__default from 'react';
import { cn } from '../../lib/utils.js';

/**
 * A pill-shaped badge displaying a search query with overlapping product images.
 * This is a "dumb" display-only component.
 */
const SearchQueryPill = ({ query, products = [], totalResults = 0, isLoading = false, isAnimating = false, className, }) => {
    const displayProducts = products.slice(0, 4);
    const remainingCount = Math.max(0, totalResults - displayProducts.length);
    const hasProducts = displayProducts.length > 0;
    // Reserve space for images even when loading to prevent layout shift
    const showImagePlaceholder = isLoading || hasProducts;
    return (React__default.createElement("div", { className: cn('tw:inline-flex tw:items-center tw:gap-2.5 tw:bg-background tw:border tw:border-primary tw:rounded-full tw:px-3 tw:py-2', 'tw:transition-all tw:duration-300 tw:max-w-full', isLoading && 'tw:animate-pulse', className) },
        React__default.createElement("span", { className: cn('tw:text-sm tw:font-medium tw:truncate tw:min-w-0 tw:transition-colors tw:duration-300', isLoading ? 'tw:text-primary/40' : 'tw:text-primary'), title: query }, query),
        showImagePlaceholder && (React__default.createElement("div", { className: "tw:flex tw:items-center tw:shrink-0" }, isLoading ? (
        // Placeholder circles during loading (no +N counter since we don't know the count yet)
        [0, 1, 2, 3].map((idx) => (React__default.createElement("div", { key: idx, className: cn('tw:size-6 tw:rounded-full tw:bg-muted tw:border tw:border-border tw:shrink-0', idx > 0 && 'tw:-ml-3'), style: { position: 'relative', zIndex: 4 - idx } })))) : (
        // Actual product images
        React__default.createElement(React__default.Fragment, null,
            displayProducts.map((product, idx) => (React__default.createElement("a", { key: `${product.stacklineSku}-${idx}`, href: `/placeholder/p/${product.stacklineSku}`, target: "_blank", rel: "noopener noreferrer", title: product.title, className: cn('tw:size-6 tw:rounded-full tw:overflow-hidden tw:bg-white tw:border tw:border-border tw:shrink-0', 'tw:transition-all tw:duration-300 hover:tw:scale-110 hover:tw:z-10', idx > 0 && 'tw:-ml-3'), style: {
                    position: 'relative',
                    zIndex: displayProducts.length - idx,
                    opacity: isAnimating ? 0 : 1,
                    transform: isAnimating ? 'scale(0.5)' : 'scale(1)',
                    animation: isAnimating ? `pillProductFadeIn 0.4s ease-out ${idx * 100}ms forwards` : 'none',
                } },
                React__default.createElement("img", { src: product.imageUrl, alt: product.title, className: "tw:w-full tw:h-full tw:object-cover" })))),
            remainingCount > 0 && (React__default.createElement("span", { className: "tw:text-sm tw:font-medium tw:text-primary/50 tw:ml-2 tw:shrink-0", title: `${remainingCount} more products`, style: {
                    opacity: isAnimating ? 0 : 1,
                    animation: isAnimating
                        ? `pillProductFadeIn 0.4s ease-out ${displayProducts.length * 100}ms forwards`
                        : 'none',
                } },
                "+",
                remainingCount)))))),
        React__default.createElement("style", null, `
        @keyframes pillProductFadeIn {
          from {
            opacity: 0;
            transform: scale(0.5);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `)));
};

export { SearchQueryPill, SearchQueryPill as default };
//# sourceMappingURL=SearchQueryPill.js.map
